import TriggerTableLine from "./TriggerTableLine"

export default class TriggerSet {
  collection = new Array()
  constructor(data = new Array) {
    let list = []
    for (let trigger = 0; trigger < data.length; trigger++) {
      list.push(new TriggerTableLine(data[trigger], data[trigger].key))
    }
    this.Set(list);
  }

  Set(triggerTable = new Array) {
    this.collection = new Array();

    for (let i in triggerTable) {
      let trigger = triggerTable[i]
      let tableLine = this.collection.find(t => {
        return t.key == trigger.key
      })
      if (tableLine)
        tableLine.setTriggerOnOff(trigger)
      else
        this.collection.push(trigger);
    }
  }
}